export function createInventoryAvailabilityClient(transport) {
    return {
        /**
         * One page of a location's stocked SKUs, in SKU order
         *
         * Requires scope: inventory:read
         */
        listInventoryAvailability(merchantId, locationId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}/inventory`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * GET /v1/merchants/{merchantId}/locations/{locationId}/inventory/{sku}
         *
         * Requires scope: inventory:read
         */
        getInventoryAvailability(merchantId, locationId, sku, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}/inventory/${encodeURIComponent(sku)}`,
                options,
            });
        },
        /**
         * PUT /internal/v1/merchants/{merchantId}/locations/{locationId}/inventory/{sku}
         *
         * Requires scope: inventory:write
         */
        setInventoryAvailability(merchantId, locationId, sku, body, options) {
            return transport.request({
                method: "PUT",
                path: `/internal/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}/inventory/${encodeURIComponent(sku)}`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/merchants/{merchantId}/locations/{locationId}/inventory/{sku}/adjust
         *
         * Requires scope: inventory:write
         */
        adjustInventoryAvailability(merchantId, locationId, sku, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}/inventory/${encodeURIComponent(sku)}/adjust`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=inventory-availability.js.map